import api from './api';
import type {
  WelcomeRule,
  WelcomeRulePayload,
  WelcomeHistoryResponse,
  WelcomeHistoryQuery,
} from '@/types/welcome';

export const welcomeRuleService = {
  async getByClient(clientId: number): Promise<WelcomeRule> {
    const result = await api.get(`/welcome-rules/client/${clientId}`) as any;
    return result?.data ?? result;
  },

  async upsert(clientId: number, payload: WelcomeRulePayload): Promise<WelcomeRule> {
    const result = await api.put(`/welcome-rules/client/${clientId}`, payload) as any;
    return result?.data ?? result;
  },

  async listHistory(
    clientId: number,
    query: WelcomeHistoryQuery = {}
  ): Promise<WelcomeHistoryResponse> {
    const params: Record<string, string> = {};
    if (query.since) params.since = query.since;
    if (query.page) params.page = String(query.page);
    if (query.limit) params.limit = String(query.limit);
    if (query.status) params.status = query.status;
    const result = await api.get(`/welcome-rules/client/${clientId}/historico`, {
      params,
    }) as any;
    return result;
  },
};
